
import {Component, Mixins, Prop} from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import IpotekForm from "@/components/forms/haciz/IpotekForm.vue";
import {IpotekEntity} from "@/entity/Haciz/IpotekEntity";

@Component({
  components: {
    FormDialog,
    DeleteDialog,
    IpotekForm,
  }
})
export default class IpotekList extends Mixins(SimpleInputMixin) {
  @Prop({}) successOnValidate !: any;
  headers = [
    {text: "İpotek Bedeli", value: "ipotek_bedeli"},
    {text: "Noter Tarihi", value: "noter_tarihi"},
    {text: "İşlemler", value: "actions", width: 150, sortable: false},
  ];
  localValue!: Array<IpotekEntity>;

  mounted() {
    if (!this.value) {
      this.localValue = [];
    }
  }

  onAdd(item: IpotekEntity) {
    this.localValue.push(item);
    this.input();
  }

  onUpdate(item: IpotekEntity, index: number) {
    let newArray = [...this.localValue];
    newArray[index] = item;
    this.localValue = newArray;
    this.input();
  }

  onDelete(index: number) {
    this.localValue.splice(index, 1);
    this.input();
  }
}
